import { Component } from 'react'
import styles from './ItemIdClipBoard.css'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { Toast, Button, Modal } from '@vzmi/shp_shared_compo'
import ItemSpecDetailTable from './ItemSpecDetailTable'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { When } from '../../../Common/Form'

const ItemIdsInRow = props => {
  const {
    itemIds = [],
    showEllipsis = false,
    showEndComma = false
  } = props
  const joinedItemIds = itemIds.join(',')
  return (
    <span>
      {joinedItemIds}
      {showEndComma && ','}
      {showEllipsis && '...'}
    </span>
  )
}

const ItemIds = props => {
  const { itemIds } = props

  const itemIdsLength = itemIds.length
  const hasMultipleItems = itemIdsLength > 1
  const hasSecondRowItemIds = itemIdsLength > 4
  const hasEllipsis = itemIdsLength > 8

  const firstRowItemIds = itemIds.slice(0, 4)
  const secondRowItemIds = itemIds.slice(4, 8)

  const classNames = cx({
    [styles.multipleItemIds]: hasMultipleItems,
    [styles.singleItemId]: !hasMultipleItems
  })

  return (
    <div
      className={classNames}
      data-role='joined-item-id'
    >
      <div className={styles.itemIdWrapper}>
        <ItemIdsInRow
          itemIds={firstRowItemIds}
          showEndComma={hasSecondRowItemIds}
        />
        <When
          value={hasSecondRowItemIds}
          isTrue
        >
          <br />
          <ItemIdsInRow
            itemIds={secondRowItemIds}
            showEllipsis={hasEllipsis}
          />
        </When>
      </div>
    </div>
  )
}

const CopyJoinedItemId = props => {
  const { joinedItemId, itemSpecs } = props

  const itemIds = itemSpecs.map(itemSpec => itemSpec.itemId)

  const itemSpecsLength = itemSpecs.length
  const hasMultipleItems = itemSpecsLength > 1

  const buttonName = hasMultipleItems
    ? `複製整筆編號(${itemSpecsLength})`
    : '複製編號'

  return (
    <div className={styles.productContent}>

      <ItemIds itemIds={itemIds} />
      <div
        key='buttons'
        className={styles.copyButton}
      >
        <CopyToClipboard
          text={joinedItemId}
          onCopy={() => Toast.success('複製成功')}
        >
          <Button
            data-role='copy-joined-item-id-button'
            size='large'
            buttonType='outline'
          >
            {buttonName}
          </Button>
        </CopyToClipboard>
      </div>
    </div>
  )
}

class ItemIdClipBoard extends Component {
  constructor (props) {
    super(props)

    this.state = {
      visible: false,
      copied: false
    }
  }

  handleCopy = () => {
    this.setState({
      copied: true
    })
    // 複製編號 成功的Toast
    Toast.success('複製成功')
  }

  showModal = () => {
    this.setState({
      visible: true
    })
  }

  handleOk = (e) => {
    this.setState({
      visible: false
    })
  }

  handleCancel = (e) => {
    this.setState({
      visible: false
    })
  }

  // render 多筆商品編號 共X筆 與 詳細商品資訊的Table
  /** ProductDetail 就是長出商品詳細資訊用的Component */
  multipleItemSpecsDetail = () => {
    const {
      itemSpecs,
      joinedItemId
    } = this.props

    const tableTitle = (<div className={styles.tableTitle}>商品資訊</div>)
    const itemSpecsLength = itemSpecs.length

    return (
      <div className={styles.detailInfoTitle}>
        <div className={styles.totalInfo}>
          {`共 ${itemSpecsLength} 筆`}
        </div>
        <>
          <Button
            data-role='show-detail-table-button'
            type='button'
            link
            size='medium'
            onClick={() => this.showModal()}
          >
            詳細商品資訊
          </Button>
          <Modal
            visible={this.state.visible}
            closable
            disableFooter
            destroyOnClose
            title={tableTitle}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            width={420}
          >
            <ItemSpecDetailTable
              joinedItemId={joinedItemId}
              itemSpecs={itemSpecs}
            />
          </Modal>
        </>
      </div>
    )
  }

  render () {
    const {
      joinedItemId,
      itemSpecs
    } = this.props

    const itemSpecsLength = itemSpecs.length
    const hasMultipleItems = itemSpecsLength > 1

    return (
      <div className={styles.ItemIdClipBoard}>
        <div className={styles.titleRegion}>
          <div className={styles.titleName}>商品編號</div>
          { hasMultipleItems && this.multipleItemSpecsDetail() }

        </div>
        <CopyJoinedItemId
          itemSpecs={itemSpecs}
          joinedItemId={joinedItemId}
        />

      </div>
    )
  }
}

ItemIdClipBoard.propTypes = {
  itemSpecs: PropTypes.array,
  joinedItemId: PropTypes.string
}

export default ItemIdClipBoard
